
const pathPush = ( object, path, value ) => {
	object[ path ] = object[ path ] || [];
	object[ path ].push( value );
	return object;
};

export default pathPush;



// WEBPACK FOOTER //
// ./src/lib/pathPush.js